import React from 'react'

import { ConfirmModal, Icon, useModalContext } from '@fourthwall/components'
import { CloseIcon } from '@fourthwall/icons'

import * as S from './MiniRecommendationDismissButton.styled'

type MiniRecommendationDropdownProps = {
  onDismiss: () => void
}

export const MiniRecommendationDismissButton = ({ onDismiss }: MiniRecommendationDropdownProps) => {
  const modal = useModalContext()

  const handleDismiss = (event: React.MouseEvent<HTMLButtonElement>) => {
    event.stopPropagation()

    modal.open(ConfirmModal, {
      title: 'Are you sure you want to hide this recommendation?',
      text: 'This action cannot be reversed.',
      confirmLabel: 'Hide recommendation',
      onConfirm: () => {
        onDismiss()
      },
    })
  }

  return (
    <S.CloseButton aria-label="Close" type="button" onClick={handleDismiss}>
      <Icon component={CloseIcon} height={12} />
    </S.CloseButton>
  )
}
